import { useCallback, useState } from 'react';
import { billService } from '../services/billService';
import type { WorkflowStep } from '../lib/billWorkflow';

// Set (or clear, with null) the person-set status step on bills — for every
// list that offers Set status: Bulk Bill Run, Bills and Bulk Customer Report.
// `onSaved` reloads whatever the list derives status from. It runs after a
// partial failure too: some of the bills may have moved.

export function useWorkflowStep(onSaved: () => void): {
  saving: boolean;
  error: string | null;
  setStep: (billIds: string[], step: WorkflowStep | null) => Promise<void>;
} {
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const setStep = useCallback(async (billIds: string[], step: WorkflowStep | null) => {
    setSaving(true);
    setError(null);
    try {
      const res = await billService.setWorkflowStep(billIds, step);
      if (!res.success) setError(res.error ?? 'Could not update the status');
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Could not update the status');
    } finally {
      setSaving(false);
      onSaved();
    }
  }, [onSaved]);

  return { saving, error, setStep };
}
